import { Upload, DatePicker, TimeSelect, Slider, Tag, Input, Button, Select, Option } from 'element-ui'
import ResourceSvc from '@/services/resource.svc.js';
import { Switch as LSwitch } from '@/components/index'
import store from '@/services/store';
import 'element-ui/lib/theme-chalk/index.css';

const svc = new ResourceSvc();

export default {
    name: 'SubscribeDetailsTab',
    components: {
        [DatePicker.name]: DatePicker,
        [TimeSelect.name]: TimeSelect,
        [Tag.name]: Tag,
        [Input.name]: Input,
        [Select.name]: Select,
        [Option.name]: Option,
        [Upload.name]: Upload,
        [Button.name]: Button,
        LSwitch,
        Upload
    },
    data() {
        return {
            countTickets: 1,
            juniorId: '',
            juniors: [],
            isProcessing: true,
            isSubscribeVisible: false,
            isVisibleCouponCodeInput: false,
            general: {
                id: 0,
                name: '',
                price: null,
                discountPrice: null,
                maxTickets: null
            },
            pricing: {
                priceMembers: null,
                priceNonMembers: null,
                couponCodeId: 0,
                couponCodeName: '',
                couponAmount: null,
                couponPercentage: null,
                shortCodeDescription: null,
                isTiMember: false
            },
            application: { questions: [] },
            custom: { questions: [] },
            pickerOptions1: {
                shortcuts: [{
                    text: 'Today',
                    onClick(picker) {
                        picker.$emit('pick', new Date())
                    }
                },
                {
                    text: 'Yesterday',
                    onClick(picker) {
                        const date = new Date()
                        date.setTime(date.getTime() - 3600 * 1000 * 24)
                        picker.$emit('pick', date)
                    }
                },
                {
                    text: 'A week ago',
                    onClick(picker) {
                        const date = new Date()
                        date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
                        picker.$emit('pick', date)
                    }
                }]
            }
        }
    },
    computed: {
        loginUrl() {
            return process.env.url.oldAppLogin;
        },
        courseId() {
            return this.$route.params.id;
        },
        purchasePrice() {
            var self = this;
            let price;
            if (self.pricing.isTiMember) {
                price = self.pricing.priceMembers;
                self.general.price = self.pricing.priceMembers;
            } else {
                price = self.pricing.priceNonMembers;
                self.general.price = self.pricing.priceNonMembers;
            }

            if (self.pricing.couponAmount) {
                var result = price * self.countTickets - self.pricing.couponAmount;
                return result > 0 ? result.toFixed(2) : 0;
            }
            else if (self.pricing.couponPercentage) {
                var result = price * self.countTickets * (100 - self.pricing.couponPercentage) / 100;
                return result > 0 ? result.toFixed(2) : 0;
            }
            return (price * self.countTickets).toFixed(2)
        }
    },
    methods: {
        switchIsVisibleCouponCodeInput(event) {
            if (event) {
                event.preventDefault();
            }
            this.isVisibleCouponCodeInput = !this.isVisibleCouponCodeInput;
        },
        addCoupon() {
            if (this.pricing.couponCodeName.length == 0 || this.pricing.couponCodeName.length > 50) {
                this.badRequestSwal("Discount code is invalid. Length should be from 1 to 50 characters")
                return;
            }

            var self = this;
            svc.validateCourseCouponCode(this.courseId, this.pricing.couponCodeName).then(response => {
                self.isProcessing = false;
                var allData = response.body;
                if (allData != null) {
                    if (allData.isSuccess == false) {//if (allData.currentUserId == 0) {//user is not logged in
                        window.location.href = self.loginUrl;
                        return;
                    }
                    self.pricing.couponCodeId = allData.courseCouponId;
                    if (self.pricing.couponCodeId == 0) {
                        self.badRequestSwal(allData.message);
                    }
                    else {
                        self.pricing.couponAmount = allData.amount;
                        self.pricing.couponPercentage = allData.percentage;
                        self.pricing.shortCodeDescription = allData.shortCodeDescription;
                        self.switchIsVisibleCouponCodeInput();
                    }
                }
                else {
                    self.badRequestSwal();
                }
            },
                response => {
                    self.badRequestSwal();
                });
        },
        addAttachment(file, filelist, question, type) {
            if (file.size > 3145728) {
                this.badRequestSwal("Max limit of the file length of 3 mb is reached. Please upload another file.");
                filelist.splice(filelist.length - 1);
            }
            else {
                var reader = new FileReader();
                reader.readAsArrayBuffer(file.raw);
                reader.onloadend = function (result) {
                    var arrayBuffer = this.result;
                    var array = new Uint8Array(arrayBuffer, 0, arrayBuffer.byteLength);
                    question.files.push({
                        id: 0,
                        name: file.name,
                        valueUrl: file.url,
                        data: array,
                        fileType: type
                    });
                }
            }
        },
        deleteAttachment(file, question, type) {
            question.files = question.files.filter(function (el) {
                return el.valueUrl != file.url;
            });
        },
        isSaveAllowed() {
            var isValid = true;
            var self = this;
            this.application.questions.forEach(function (q) {
                if ((((q.type === 1 || q.type === 3) && q.isRequired) || (q.type === 4 && q.isChecked)) && (self.isEmptyOrSpaces(q.answer))) {
                    q.isEmpty = true;
                    isValid = false;
                }
                else
                if (!self.isValueValidForAnswerType(q.answer, q.typeAnswer)) {
                    if (!q.isChecked && q.type == 4) {
                        return;
                    }
                    q.isNotCorrectFormat = true;
                    isValid = false;
                }
                else
                if ((q.type === 5 || q.type === 6) && q.isRequired && q.files.length == 0) {
                    q.isEmpty = true;
                    isValid = false;
                }
            });

            this.custom.questions.forEach(function (q) {
                if ((((q.type === 1 || q.type === 3) && q.isRequired) || (q.type === 4 && q.isChecked)) && (self.isEmptyOrSpaces(q.answer))) {
                    q.isEmpty = true;
                    isValid = false;
                }
                else
                if(!self.isValueValidForAnswerType(q.answer, q.typeAnswer) && q.answer) {
                    if (!q.isChecked && q.type == 4) {
                        return;
                    }
                    q.isNotCorrectFormat = true;
                    isValid = false;
                }
                else
                if ((q.type === 5 || q.type === 6) && q.isRequired && q.files.length == 0) {
                    q.isEmpty = true;
                    isValid = false;
                }
            });
            return isValid;
        },
        isValueValidForAnswerType(value, type) {
            switch (type) {
                case 1:
                    return true;
                case 2:
                    return true;
                case 3:
                    return !isNaN(parseFloat(value)) && isFinite(value);
                case 4:
                    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    return re.test(String(value).toLowerCase());
                case 5:
                    return this.isValidURL(value);
                case 6:
                    return true;
                default:
                    return true;
            }
        },
        isValidURL(str) {
            try {
                new URL(str);
                return true;
            } catch (_) {
                if (str.indexOf('.') == -1) {
                    return false;
                }
            }

            try {
                new URL('http://' + str);
                return true;
            } catch (_) {
                return false;
            }
        },
        isEmptyOrSpaces(str) {
            return str === null || str === undefined || String(str).match(/^ *$/) !== null;
        },
        loadData() {
            var self = this;
            self.isProcessing = true;
            self.isSubscribeVisible = false;
            svc.getCourseApplicationDetailsForUser(self.general.id, self.juniorId).then(response => {
                var allData = response.body;
                if (allData) {
                    if (!allData.isSuccess) {
                        if (!allData.currentUserId) {//user is not logged in
                            window.location.href = self.loginUrl;
                            return;
                        }
                        else if (allData.currentUserId > 0) {//we have this attendant, he not paid
                            self.badRequestWithRedirect("Registration was done earlier. Now, you will be redirected to the billing info page.", "/course/billing/" + self.general.id);//other reasons
                            return;
                        }
                        
                        self.badRequestSwal(allData.message);//other reasons
                        self.isProcessing = false;
                        return;
                    }

                    self.general.id = allData.generalDetails.id;
                    self.general.name = allData.generalDetails.name;
                    self.general.maxTickets = allData.generalDetails.maxTickets;
                    self.application.questions = allData.applicationDetails.applicationFields;
                    self.custom.questions = allData.customQuestions;

                    self.pricing.priceMembers = allData.pricingDetails.priceMembers;
                    self.pricing.priceNonMembers = allData.pricingDetails.priceNonMembers;
                    self.pricing.isTiMember = allData.pricingDetails.isTiMember;

                    if (allData.pricingDetails.isTiMember) {
                        self.general.price = allData.pricingDetails.priceMembers;
                    } else {
                        self.general.price = allData.pricingDetails.priceNonMembers;
                    }
                }
                self.isProcessing = false;
                self.isSubscribeVisible = true;
            },
                response => {
                    self.badRequestWithRedirect("Something went wrong", "/course/" + self.courseId);
                    self.isProcessing = false;
                });
        },
        saveData() {
            if (!this.isSaveAllowed()) {
                this.badRequestSwal("Please fill required fields!");
                return;
            }

            var self = this;
            self.isProcessing = true;
            self.isSubscribeVisible = false;
            window.scrollTo(0, 0);

            var data = {
                generalDetails: {
                    id: this.general.id,
                    name: this.general.name,
                    takeTickets: this.countTickets
                },
                applicationDetails: {
                    ApplicationFields: this.application.questions
                },
                pricingDetails: {
                    priceMembers: self.pricing.priceMembers,
                    priceNonMembers: self.pricing.priceNonMembers,
                    couponCodeId: self.pricing.couponCodeId
                },
                customQuestions: this.custom.questions,
                currentUserId: 0,
                registerUserId: this.juniorId
            }

            svc.addNewAttendance(data).then(response => {
                var allData = response.body;
                self.isProcessing = false;
                if (!allData) {
                    self.badRequestSwal("Something went wrong!");
                    return;
                }

                if (!allData.isSuccess) {
                    if (allData.currentUserId == 0) {
                        window.location.href = self.loginUrl;
                        return;
                    }
                    self.isProcessing = false;
                    self.badRequestSwal("Something went wrong!");
                    self.isSubscribeVisible = true;
                }
                else {
                    if (allData.isConfirmed) {
                        var redirectUrl = "/course/thankyou/" + self.courseId;
                        var message = "Congratulations. You are registered on this course!";

                        // allData.registerUserId !== allData.currentUserId means that course is bought for junior
                        // so we need another type of handling
                        if (allData.registerUserId && allData.registerUserId !== allData.currentUserId) {
                            redirectUrl += `?registerId=${allData.registerUserId}`;
                            message = "Congratulations. Junior is registered on this course!";
                        }
                        self.successSwalWithRedirect(message, redirectUrl);
                    }
                    else {
                        self.successSwalWithRedirect("Data succesfully saved. You will be redirected to biilling info page!", "/course/billing/" + data.generalDetails.id);
                    }
                    
                }

            }, response => {
                var redirectUrl = "/course/" + self.courseId;
                self.badRequestWithRedirect(null, redirectUrl);
            });
        },
        badRequestSwal(message) {
            if (!message) {
                message = 'Something went wrong. Incorrect request!';
            }
            this.$notify({
                message: message,
                type: 'danger',
                timeout: 10000
            });
        },
        badRequestWithRedirect(message, redirectUrl) {
            var self = this;
            if (!message) {
                message = 'Something went wrong!';
            }

            this.$notify({
                message: message,
                type: 'danger',
                timeout: 10000
            });

            if (redirectUrl)
                try {
                    setTimeout(function () {
                        self.$router.push({ path: redirectUrl });
                    }, 3000);
                }
                catch (e) { }
        },
        successSwalWithRedirect(message, redirectUrl) {
            var self = this;
            if (!message) {
                message = 'Operation success!';
            }

            this.$notify({
                message: message,
                type: 'success',
                timeout: 10000
            });

            if (redirectUrl)
                try {
                    setTimeout(function () {
                        self.$router.push({ path: redirectUrl });
                    }, 3000);
                }
                catch (e) { }
        },
        checkUserAndLoadInfoIfHasNoJuniorsOrLoadListOfJunior() {
            var self = this;
            self.isProcessing = true;
            svc.getCourseApplicationStatusForUser(self.general.id).then(response => {
                var allData = response.body;
                if (allData) {
                    if (!allData.isSuccess) {
                        if (!allData.currentUserId) {//user is not logged in
                            window.location.href = self.loginUrl;
                            return;
                        }
                        else if (allData.currentUserId > 0) {//we have this attendant, he not paid
                            self.badRequestWithRedirect("Registration was done earlier. Now, you will be redirected to the billing info page.", "/course/billing/" + self.courseId);//other reasons
                            return;
                        }
                        self.badRequestWithRedirect(allData.message, "/course/" + self.courseId);//other reasons
                        return;
                    }

                    if (allData.juniors && allData.juniors.length) {
                        self.juniors = allData.juniors;
                    }
                    else {
                        self.juniorId = allData.registerUserId;
                        self.general.name = allData.generalDetails.name;
                        self.general.maxTickets = allData.generalDetails.maxTickets;
                        self.application.questions = allData.applicationDetails.applicationFields;
                        self.custom.questions = allData.customQuestions;

                        self.pricing.priceMembers = allData.pricingDetails.priceMembers;
                        self.pricing.priceNonMembers = allData.pricingDetails.priceNonMembers;
                        self.pricing.isTiMember = allData.pricingDetails.isTiMember;

                        self.isSubscribeVisible = true;
                    }
                }
                self.isProcessing = false;
            },
                response => {
                    self.badRequestWithRedirect("Something went wrong", "/course/" + self.courseId);
                    self.isProcessing = false;
                });
        }
    },
    created() {
        this.general.id = this.courseId;
        //this.loadData();
        this.checkUserAndLoadInfoIfHasNoJuniorsOrLoadListOfJunior();
    },
    mounted() {
        var user = store.getters.getCurrentUser;
        if (user && user.roles && user.roles.length) {
            if (user.roles.some(function (el) { return el === "Admin"; })) {
                this.$router.push("admin/courses");
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/user/courses/course-details/subscribe-tab/subscribe-tab.js